import React from "react";
import { Navigate } from "react-router-dom";
import { UserService } from "../../services/UserService";

// A signed-in non-admin goes home, not to the login page: they are logged in, just not allowed here.
const AdminRoute = ({ children }) => {
  if (!UserService.isLoggedIn || UserService.isUserTokenExpired) {
    return <Navigate to="/login" replace />;
  }
  if (!UserService.isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default AdminRoute;
